import { Link } from "react-router-dom";
import { mangaWorks } from "@/mocks/manga";
import MangaCard from "@/components/feature/MangaCard";

export default function Featured() {
  const featured = mangaWorks.filter((w) => w.featured);
  const spotlight = featured[0];
  const rest = featured.slice(1);

  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-9 flex items-end justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm text-accent-500">
              <i className="ri-star-smile-line"></i> 编辑精选
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              编辑部私藏，值得一读再读
            </h2>
          </div>
          <Link to="/category/xueguo" className="hidden items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 sm:inline-flex">
            全部精选 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* 头牌作品 Spotlight */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div className="relative mx-auto w-full max-w-sm overflow-hidden rounded-xl border border-background-200/70 lg:max-w-none">
            <div className="relative aspect-[3/4]">
              <img
                src={spotlight.cover}
                alt={`${spotlight.title} 编辑精选封面`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-sm font-semibold text-foreground-950">
                <i className="ri-award-line"></i> 本期头牌
              </span>
            </div>
          </div>

          <div>
            <div className="flex flex-wrap items-center gap-2">
              {spotlight.tags.map((t) => (
                <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100/70 px-3 py-1 text-xs text-foreground-700">{t}</span>
              ))}
              <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-accent-500/40 px-3 py-1 text-xs text-accent-500">
                <i className="ri-star-fill"></i> {spotlight.rating.toFixed(1)}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{spotlight.title}</h3>
            <p className="mt-2 text-sm text-foreground-500">
              {spotlight.categoryName} · 作者 {spotlight.author} · 绘者 {spotlight.artist} · {spotlight.status}
            </p>
            <p className="mt-5 leading-7 text-foreground-600">{spotlight.intro}</p>
            <p className="mt-3 leading-7 text-foreground-600">{spotlight.longIntro}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to={`/work/${spotlight.id}`}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line"></i> 开始阅读
              </Link>
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700">
                <i className="ri-file-list-3-line text-primary-500"></i> 已更新 {spotlight.episodes} 话
              </span>
            </div>
          </div>
        </div>

        {/* 其余精选 */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((w) => (
            <MangaCard key={w.id} work={w} />
          ))}
        </div>
      </div>
    </section>
  );
}